<template>
    <div class='signMsg-panel' v-if="isShow">
        <div class='signMsg-warpper'>
            <div class='signMsg-title'>请完善个人报名信息</div>
            <p class='signMsg-tip'>*仅用于官方联系发放活动奖品</p>
            <div class='signMsg-item'>
                <span class='item-title'>收件姓名</span>
                <input class='item-inp' type="text" v-model="name" placeholder="请输入本人姓名" maxlength="20">
            </div>

            <div class='signMsg-item ' v-bind:class="{ 'signMsg-phone': hasMsg?(isChangePhone?true:false):true }">
                <span class='item-title'>手机号</span>
                <input class='item-inp' type="text" v-model="phone"  placeholder="请输入本人手机" v-on:keyup="changePhone" maxlength="11">
                <span class='item-btn' v-on:click='getCode' v-bind:style="{ cursor: verification.hasActive? 'not-allowed':'pointer' }">{{verification.text}}</span>
            </div>
            <div class='signMsg-item  signMsg-phone' v-if="hasMsg?(isChangePhone?true:false):true">
                <span class='item-title'>验证码</span>
                <input class='item-inp' type="text"  v-model="code" placeholder="请输入手机验证码">
            </div>

            
            <div class='signMsg-item'>
                <span class='item-title'>收件地址</span>
                <input  class='item-inp' type="text"  v-model="address" placeholder="请输入本人常用收件地址" maxlength="225">
            </div>
            <div class='signMsg-item'>
                <span class='item-title'>QQ</span>
                <input  class='item-inp' type="text"  v-model="qq" placeholder="请输入本人常用QQ号" maxlength="20">
            </div>
            <div class='signMsg-btn'>
                <span class='btn btn-no' v-on:click='isShow = false'>取消</span>
                <span class='btn  btn-yes' v-on:click='btnYes'>确认</span>
            </div>
        </div>
    </div>
</template>
<script>
//const rulePhone =  /^((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[03678]{1})|(14[5789]{1}))+\d{8}$/;
const rulePhone =  /^1\d{10}$/;
export default {
    name: 'signMsg',
    data(){
        return{
            type: '',
            isGetUserMsg: false,
            isShow: false,
            hasMsg: false,
            isChangePhone: false,
            name:'',
            phone:'',
            address:'',
            code:'',
            qq:'',
            prevMsg: null,
            verification:{
                text: '发送验证码',
                tid: null,
                hasActive:false
            }
        }
    }, 
    methods :{
        show: function(res){
            this.type = res.type;
            this.isShow = true;
            this.getUserSignMsg();
        },
        hide: function(){
            this.isShow = false;
        },
        changePhone: function(){
            if(this.prevMsg && this.prevMsg.phone != this.phone){
                this.isChangePhone = true;
            }else{
                this.isChangePhone = false;
            }
        },
        updateTime: function(time) {
            let _this = this;
            this.verification.hasActive = true;
            time--;
            this.verification.text =  time + " s";
            if (time > 0) {
                this.verification.tid = setTimeout(() => {
                    _this.updateTime(time);
                }, 1000);
            } else {
                clearTimeout(this.verification.tid);
                this.verification.text = "重新获取";
                this.verification.hasActive = false;
            }
        },
        getCode: function(){
            let _this = this;
            if(!this.verification.hasActive){
                if(_this.phone != ''){
                    
                    if(rulePhone.test(_this.phone)){
                        _this.$server.getCode({phone: _this.phone}).then(function(res){
                            res = res.data;
                            if(res.code == 0){
                                _this.updateTime(60);
                            }else{
                                _this.$tipsBox.error({
                                    message: "服务器开小差，请稍后再试..."
                                });
                            }
                        }).catch(function(){
                            _this.$tipsBox.error({
                                message: "服务器开小差，请稍后再试..."
                            });
                        });
                    }else{
                        _this.$tipsBox.error({
                            message: '请输入正确的手机号'
                        });
                    }
                }else{
                    _this.$tipsBox.error({
                        message: '请先输入手机号'
                    });
                }
            } 
        },
        getUserSignMsg:function(){
            let _this = this;
            if(!_this.isGetUserMsg){
                _this.isGetUserMsg = true;
                _this.$server.getUserSignMsg().then(function(res){
                    res = res.data;
                    if (res.code == 10010) {
                        _this.$tipsBox.error({
                            message: "请先登录",
                            reload: "http://5sing.kugou.com/login/"
                        });
                    } else if (0 === res.status) {
                        if(res.data.length == 0){
                            _this.hasMsg = false;
                        }else{
                            _this.hasMsg = true;
                            _this.prevMsg = res.data;
                            _this.name = res.data.name;
                            _this.phone = res.data.phone;
                            _this.qq = res.data.qq;
                            _this.address = res.data.address;
                        }
                    } else {
                        _this.$tipsBox.error({
                            message: res.message
                        });
                    }
                }).catch(function(){
                    _this.$tipsBox.error({
                        message: "服务器开小差，请稍后再试..."
                    });
                });
            }
        },
        btnYes: function(){
            let _this = this;
            if(_this.name == ''){
                _this.$tipsBox.error({
                    message: "请先输入本人姓名"
                });
                return ;
            }
            if(_this.phone == ''){
                _this.$tipsBox.error({
                    message: "请先输入手机号"
                });
                return ;
            }else if(!rulePhone.test(_this.phone)){
                _this.$tipsBox.error({
                    message: '请先输入正确的手机号'
                });
                return ;
            }
            if(_this.code == '' && _this.isChangePhone){
                _this.$tipsBox.error({
                    message: "请先输入验证码"
                });
                return ;
            }
            if(_this.address == ''){
                _this.$tipsBox.error({
                    message: "请先输入本人常用收件地址"
                });
                return ;
            }
            if(_this.qq == ''){
                _this.$tipsBox.error({
                    message: "请先输入本人常用QQ号"
                });
                return ;
            }
            if(!_this.hasMsg){
                this.setUserSignMsg();
            }else if(_this.address != _this.prevMsg.address || _this.name != _this.prevMsg.name || _this.qq != _this.prevMsg.qq  || _this.phone != _this.prevMsg.phone){
                this.setUserSignMsg();
                
            }else{
                _this.hide();
                eventbus.$emit("signMsg", {type:'signSuccess-'+_this.type});
            }
        },
        setUserSignMsg: function(){
            var _this = this;
            var formData = {
                name: _this.name,
                phone: _this.phone,
                qq: _this.qq,
                code: _this.code,
                address: _this.address
            }
            _this.$server.setUserSignMsg(formData).then(function(res){
                res = res.data;
                if (res.code == 10010) {
                    _this.$tipsBox.error({
                        message: "请先登录",
                        reload: "http://5sing.kugou.com/login/"
                    });
                } else if (0 === res.status) {
                    _this.updateTime(0);
                    _this.hide();
                    eventbus.$emit("signMsg", {type:'signSuccess-'+_this.type});
                    //注册用户信息成功，可以重新获取用户信息
                    _this.isGetUserMsg = false;
                } else {
                    _this.$tipsBox.error({
                        message: res.message
                    });
                }
                
            }).catch(function(){
                _this.$tipsBox.error({
                    message: "服务器开小差，请稍后再试..."
                });
            });
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.signMsg-panel{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,.5);
    z-index: 100;
    .signMsg-warpper{
        position: absolute;
        top:50%;
        left: 50%;
        margin-top: -200px;
        margin-left: -200px;
        width: 400px;
        color: #333;
        border: 1px solid #2a0e5e;
        border-top-width: 6px;
        border-bottom-width: 6px;
        background-color: #fff;
        .signMsg-title{
            padding: 13px 0;
            text-align: center;
        }
        .signMsg-tip{
            padding:0  10px  10px 10px;
            font-size: 13px;
        }
        .signMsg-item{
            padding-top: 13px;
            .item-title{
                display: inline-block;
                width: 20%;
                margin-right: 5px;
                color: #7a7a7a;
                text-align: right;
            }
            .item-inp{
                width: 72%;
                height: 40px;
                padding: 5px;
                box-sizing: border-box;
                vertical-align: middle;
                &::-webkit-input-placeholder{
                    color:#7a7a7a;
                }
                &::-moz-placeholder{   /* Mozilla Firefox 19+ */
                    color:#7a7a7a;
                }
                &::-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
                    color:#7a7a7a;
                }
            }
            .item-btn{
                display: none;
            }
        }
        .signMsg-phone{
            .item-inp{
                width: 50%;
            }
            .item-btn{
                display: inline-block;
                width: 80px;
                line-height: 40px;
                height: 40px;
                color:#2a0e5e;
                font-size: 12px;
                text-align: center;
                border: 1px solid #2a0e5e;
                border-radius: 5px;
                vertical-align: top;
                cursor: pointer;
            }
        }
        .signMsg-btn{
            margin-top: 20px;
            font-size: 0;
            border-top: 1px solid #2a0e5e;
            .btn{
                display: inline-block;
                width: 49.5%;
                height: 45px;
                line-height: 45px;
                font-size: 15px;
                text-align: center;
                cursor: pointer;
            }
            .btn-no{
                color: #7a7a7a;
                border-right: 1px solid #2a0e5e;
            }
            .btn-yes{
                color: #2a0e5e;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/sign-msg/sign-msg.vue